const $win = $(window)
const $header = $('.js-header')
const $main = $('.js-main')
const $widgetCart = $('.js-widget-cart')
const $navDropdown = $('.js-nav-dropdown')
let timeout

$win
  .on('load resize scroll', function () {
    if ($header.length) {
      const winO = $win.scrollTop();
      const isHeaderFixed = winO > 0;
      const winHeight = $win.height()
      const headerHeight = parseInt($header.outerHeight())
      const headerPaddingBottom = parseInt($header.css('padding-bottom'))

      $header.toggleClass('is-fixed', isHeaderFixed);

      if ($main.length) {
        clearTimeout(timeout)

        timeout = setTimeout(function () {
          $main.css('padding-top', parseInt($header.outerHeight()))
        }, 410)
      }

      if ($widgetCart.length) {
        $widgetCart.css('max-height', winHeight - (headerHeight - headerPaddingBottom))
      }

      if ($navDropdown.length) {
        $navDropdown.css('max-height', winHeight - (headerHeight - headerPaddingBottom))
      }
    }
  })
